import { render, staticRenderFns } from "./Aplicacoes.vue?vue&type=template&id=6076bec8&scoped=true"
import script from "./Aplicacoes.vue?vue&type=script&lang=js"
export * from "./Aplicacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6076bec8",
  null
  
)

export default component.exports